import PageWrapper from "../components/animations/PageWrapper";
import AnimatedCard from "../components/ui/AnimatedCard";
import CardHeader from "../components/ui/CardHeader";
import CardDetails from "../components/ui/CardDetails";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Experiences() {
  return (
    <main className="page-content">
      <PageWrapper>
        <section id="experiences">
            <Link to="/accueil" className="back-link" aria-label="Retour à l'accueil">
              <ArrowLeft size={18} />
              <span>Accueil</span>
            </Link>
            <h2>Expériences professionnelles</h2>
            {[
              {
                titre: "Stage LLM",
                date: "3 mois · Mai à Août 2025",
                entreprise: "Matmut",
                description: "Développement d'un <strong>chatbot multi-agent</strong> utilisant un RAG pour répondre à des questions métiers ou utilisateurs dans le cadre des assurances Matmut. Architecture multi-agent communiquant via le <strong>protocole MCP</strong>. Un <strong>frontend en ReactJS</strong> a également été développé pour permettre l'interaction des utilisateurs avec l'agent.",
                details: [
                  { label: "Langages", value: "Python, JavaScript" },
                  { label: "Framework", value: "ReactJS" },
                  { label: "Bases de données", value: "MongoDB, Elasticsearch" },
                  { label: "Outils", value: "Ollama, LangSmith" },
                  { label: "Protocole", value: "MCP" }
                ]
              },
              {
                titre: "Recruteur de donateur",
                date: "6 semaines · Juillet à Août 2024",
                entreprise: "Handicap International",
                description: "Recherche de fonds en équipe pour l'association Handicap International."
              },
              {
                titre: "Opérateur dans un entrepôt",
                date: "1 mois · Août 2022",
                entreprise: "Stellantis",
                description: "Gestion en équipe de pièces de garage dans un entrepôt."
              },
              {
                titre: "Animateur avec adultes en situation de handicap",
                date: "3 semaines · Août 2021",
                entreprise: "Cap'Evasion",
                description: "Gestion en équipe du quotidien des adultes et de leurs activités sur un lieu de vacances."
              }
            ].map((exp, index) => (
              <AnimatedCard key={index}>
                <CardHeader
                  title={exp.titre}
                  subtitle={exp.entreprise}
                  meta={exp.date}
                />
                {/* render description as HTML to allow <strong> emphasis */}
                <p dangerouslySetInnerHTML={{ __html: exp.description }} />
                {exp.details && <CardDetails details={exp.details} />}
              </AnimatedCard>
            ))}
        </section>
      </PageWrapper>
    </main>
    );
}